import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import PropTypes from 'prop-types';
import { NavLink, withRouter } from 'react-router-dom';
import ExternalLink from '../Link/ExternalLink';

export function TopNavigationLink({
  url, meta, className, t, isGrouped,
}) {
  return (meta.isExternal
    ? (
      <ExternalLink amplitudeTarget={meta.amplitudeTarget} amplitudeEvent={meta.amplitudeEvent} href={url} className={`is-uppercase title is-4 is-marginless navbar-item ${className}`} text={meta.text}>
        {meta.image && <img alt={meta.altText} src={meta.image} style={{ width: meta.width, height: meta.height }} />}
      </ExternalLink>
    )
    : (
      <NavLink to={url} className={`is-uppercase title is-4 is-marginless ${isGrouped ? 'control' : 'navbar-item'} ${className}`} activeClassName="is-active" exact>
        <span className={`${meta.type === 'button' ? 'button' : ''}`}>
          {t(meta.text)}
          {meta.image && <img alt={meta.altText} src={meta.image} style={{ width: meta.width, height: meta.height }} />}
        </span>
      </NavLink>
    )
  );
}
TopNavigationLink.defaultProps = {
  className: '',
  isGrouped: false,
  t: (str) => str,
};
TopNavigationLink.propTypes = {
  className: PropTypes.string,
  isGrouped: PropTypes.bool,
  url: PropTypes.string.isRequired,
  meta: PropTypes.object.isRequired,
  t: PropTypes.func,
};
export const TopNavigationLinkTranslated = translate()(TopNavigationLink);

function mapStateToProps(state) {
  return {
    userAuthenticated: state.app.authKey !== null,
  };
}
function getLinkForSection(link, section, userAuthenticated) {
  return link.section === section
    && (
      (!link.onlyUnauthorized && !link.onlyAuthorized)
      || (userAuthenticated && link.onlyAuthorized)
      || (!userAuthenticated && link.onlyUnauthorized)
    );
}
export class TopNavigationComponent extends PureComponent {
  static propTypes = {
    userAuthenticated: PropTypes.bool.isRequired,
    links: PropTypes.object.isRequired,
  }

  state = {
    burgerActive: false,
  }

  toggleBurger = (burgerActive) => this.setState(() => ({ burgerActive }))

  render() {
    const { links, userAuthenticated } = this.props;
    const { burgerActive } = this.state;
    const brand = Object.keys(links).filter((l) => getLinkForSection(links[l], 'brand', userAuthenticated));
    const start = Object.keys(links).filter((l) => getLinkForSection(links[l], 'start', userAuthenticated));
    const end = Object.keys(links).filter((l) => getLinkForSection(links[l], 'end', userAuthenticated));
    const endGroup = Object.keys(links).filter((l) => getLinkForSection(links[l], 'endgroup', userAuthenticated));
    return (
      <nav className="navbar has-shadow is-on-top">
        <div className="navbar-brand">
          {brand.map((l) => <TopNavigationLinkTranslated key={l} url={l} meta={links[l]} className={links[l].className} />,)}
          {(start.length > 0 || end.length > 0 || endGroup.length > 0)
        && (
        <div tabIndex="0" role="button" aria-label="mobile-menu-opener" className={`navbar-burger${burgerActive ? ' is-active' : ''}`} onClick={() => this.toggleBurger(!burgerActive)}>
          <span />
          <span />
          <span />
        </div>
        )}
        </div>
        <div className={`navbar-menu has-text-centered-touch ${burgerActive ? 'is-active' : ''}`}>
          <div className="navbar-start">
            {start.map((l) => <TopNavigationLinkTranslated key={l} url={l} meta={links[l]} className={links[l].className} />,)}
          </div>
          <div className="navbar-end">
            {end.map((l) => <TopNavigationLinkTranslated key={l} url={l} meta={links[l]} className={links[l].className} />,)}
            {endGroup.length > 0 && (
            <div className="navbar-item control">
              <div className="field is-grouped">
                {endGroup.map((l) => <TopNavigationLinkTranslated isGrouped key={l} url={l} meta={links[l]} className={links[l].className} />,)}
              </div>
            </div>
            )}
          </div>
        </div>
      </nav>
    );
  }
}
export default withRouter(connect(mapStateToProps)(TopNavigationComponent));
